module.exports = __webpack_public_path__ + "static/media/1019668.3c7bfcbf.jpg";